import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { getBaseUrl } from './utils/routing';
import './styles/index.css';

// Import StateExporter for development mode
if (import.meta.env.DEV) {
  import('./utils/stateExporter').then(({ StateExporter }) => {
    // StateExporter will be automatically exposed to window in development
    console.log('StateExporter loaded for development');
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={getBaseUrl()}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 